// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/DynamicFacet/_DynamicFacetHeader.scss
// module id = 567
// module chunks = 2 4 8 88